import Company from "./views/company/Company.vue";

export default {
	router: [
		{
			path: "/commercial/manage_campaigns",
			name: "manage_campaigns",
			component: Company,
			params: { menu: "manage campaigns" },
			meta: { gtm: "Manage campaigns" },
		},
		{
			path: "/commercial/manage_partners",
			name: "manage_partners",
			component: Company,
			params: { menu: "manage partners" },
			meta: { gtm: "Manage partners" },
		},
	]
}